import { useEffect, useState } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import axios from "../api/axios";
import useVerify from "../hooks/verify/useVerify";

const Verify = () => {
  const navigate = useNavigate();
  const [err, setErr] = useState(false);
  const { dispatch } = useVerify();
  const queryToken = useLocation().search.split("?")[1].split("=")[1];
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // function setVerification() {
  const verifyToken = async () => {
    if (!queryToken) {
      return Error("No Token Was Found");
    }
    try {
      await axios.get(`/v1/link?token=${queryToken}`).then((res) => {
        const verification = {
          token: res.data.token,
          isVerified: true,
        };
        dispatch({
          type: "SET_VERIFY",
          verification: verification,
        });
        setTimeout(() => {
          setIsLoading(false);
          navigate(`/register`, {
            replace: true,
          });
        }, 500);
      });
    } catch (error) {
      console.error(error);
      setErr(true);
      setIsLoading(false);
    }
  };
  // verifyToken();
  // }
  useEffect(() => {
    let ret = async () => await verifyToken();
    ret();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isLoading) return <div></div>;
  return !err ? (
    <Navigate to={"/register"} replace />
  ) : (
    <Navigate to={"/"} replace />
  );
};
export default Verify;
